import { lexonHttp } from "@/plugins/axios/lexonHttp";

export class MenusService {
  constructor() {}

  getData(url: string) {
    return lexonHttp.get(url)
  }
}
